import { render, staticRenderFns } from "./ChatLeftSidebar.vue?vue&type=template&id=1f1a6e25"
import script from "./ChatLeftSidebar.vue?vue&type=script&lang=js"
export * from "./ChatLeftSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports